
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
// Import build information
// Auto-generated build information
const $04b8cf952a63a727$export$d99074480c2c53b7 = {
    "commit": "78a5f306",
    "buildTime": "2025-10-30T23:53:22.313Z"
};


var $879d8210211d0bfa$exports = {};

$parcel$export($879d8210211d0bfa$exports, "create", () => $879d8210211d0bfa$export$185802fd694ee1f5);
$parcel$export($879d8210211d0bfa$exports, "fromMat4", () => $879d8210211d0bfa$export$b4ad467060d346fe);
$parcel$export($879d8210211d0bfa$exports, "clone", () => $879d8210211d0bfa$export$9cd59f9826255e47);
$parcel$export($879d8210211d0bfa$exports, "copy", () => $879d8210211d0bfa$export$784d13d8ee351f07);
$parcel$export($879d8210211d0bfa$exports, "fromValues", () => $879d8210211d0bfa$export$a82be99ed2a44a7d);
$parcel$export($879d8210211d0bfa$exports, "set", () => $879d8210211d0bfa$export$adaa4cf7ef1b65be);
$parcel$export($879d8210211d0bfa$exports, "identity", () => $879d8210211d0bfa$export$f0954fd7d5368655);
$parcel$export($879d8210211d0bfa$exports, "transpose", () => $879d8210211d0bfa$export$9cb09a71b7d66923);
$parcel$export($879d8210211d0bfa$exports, "invert", () => $879d8210211d0bfa$export$6897c284b6f9f4dc);
$parcel$export($879d8210211d0bfa$exports, "adjoint", () => $879d8210211d0bfa$export$33f3c024b4ae00a1);
$parcel$export($879d8210211d0bfa$exports, "determinant", () => $879d8210211d0bfa$export$a04698f914c55ed9);
$parcel$export($879d8210211d0bfa$exports, "multiply", () => $879d8210211d0bfa$export$2060d2db72cce88f);
$parcel$export($879d8210211d0bfa$exports, "translate", () => $879d8210211d0bfa$export$d73ee8ef04f5226a);
$parcel$export($879d8210211d0bfa$exports, "rotate", () => $879d8210211d0bfa$export$bb628a54ab399bc9);
$parcel$export($879d8210211d0bfa$exports, "scale", () => $879d8210211d0bfa$export$dcdf75081b88279d);
$parcel$export($879d8210211d0bfa$exports, "fromTranslation", () => $879d8210211d0bfa$export$bc9e79e74e9fddf6);
$parcel$export($879d8210211d0bfa$exports, "fromRotation", () => $879d8210211d0bfa$export$926fc125ff3c666c);
$parcel$export($879d8210211d0bfa$exports, "fromScaling", () => $879d8210211d0bfa$export$832ca188ffb1955d);
$parcel$export($879d8210211d0bfa$exports, "fromMat2d", () => $879d8210211d0bfa$export$68f5977575fae9bf);
$parcel$export($879d8210211d0bfa$exports, "fromQuat", () => $879d8210211d0bfa$export$2ff2bbe382249af7);
$parcel$export($879d8210211d0bfa$exports, "normalFromMat4", () => $879d8210211d0bfa$export$966b25ab6dc1b1f9);
$parcel$export($879d8210211d0bfa$exports, "projection", () => $879d8210211d0bfa$export$b74061472fe7c07);
$parcel$export($879d8210211d0bfa$exports, "str", () => $879d8210211d0bfa$export$42d51816ce590c93);
$parcel$export($879d8210211d0bfa$exports, "frob", () => $879d8210211d0bfa$export$326827e8268e9cdb);
$parcel$export($879d8210211d0bfa$exports, "add", () => $879d8210211d0bfa$export$e16d8520af44a096);
$parcel$export($879d8210211d0bfa$exports, "subtract", () => $879d8210211d0bfa$export$4e2d2ead65e5f7e3);
$parcel$export($879d8210211d0bfa$exports, "multiplyScalar", () => $879d8210211d0bfa$export$c697bed75648cdb7);
$parcel$export($879d8210211d0bfa$exports, "multiplyScalarAndAdd", () => $879d8210211d0bfa$export$553579f63bdd7137);
$parcel$export($879d8210211d0bfa$exports, "exactEquals", () => $879d8210211d0bfa$export$f2599a5cf1109d8);
$parcel$export($879d8210211d0bfa$exports, "equals", () => $879d8210211d0bfa$export$e9bab7fafb253603);
$parcel$export($879d8210211d0bfa$exports, "mul", () => $879d8210211d0bfa$export$6e3a27864ab166fe);
$parcel$export($879d8210211d0bfa$exports, "sub", () => $879d8210211d0bfa$export$f93b5905241a7cca);
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $78ae820aa9ececfa$export$fd293b15f47e270 = 0.000001;
var $78ae820aa9ececfa$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $78ae820aa9ececfa$export$5ada478c8a628231 = Math.random;
var $78ae820aa9ececfa$export$217057687ee20298 = "zyx";
function $78ae820aa9ececfa$export$2077e0241d6afd3c(a) {
    if (a >= 0) return Math.round(a);
    return a % 0.5 === 0 ? Math.floor(a) : Math.round(a);
}
function $78ae820aa9ececfa$export$cb2c0eb57f5e532c(type) {
    $78ae820aa9ececfa$export$b67359430d3b1b2 = type;
}
var $78ae820aa9ececfa$var$degree = Math.PI / 180;
var $78ae820aa9ececfa$var$radian = 180 / Math.PI;
function $78ae820aa9ececfa$export$408b8ee5959eefd5(a) {
    return a * $78ae820aa9ececfa$var$degree;
}
function $78ae820aa9ececfa$export$c796d9d3e501591f(a) {
    return a * $78ae820aa9ececfa$var$radian;
}
function $78ae820aa9ececfa$export$e9bab7fafb253603(a, b) {
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $78ae820aa9ececfa$export$fd293b15f47e270;
    return Math.abs(a - b) <= tolerance * Math.max(1, Math.abs(a), Math.abs(b));
}


function $879d8210211d0bfa$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(9);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$b4ad467060d346fe(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
}
function $879d8210211d0bfa$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(9);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$a82be99ed2a44a7d(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(9);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $879d8210211d0bfa$export$adaa4cf7ef1b65be(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $879d8210211d0bfa$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
}
function $879d8210211d0bfa$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b01 = a22 * a11 - a12 * a21;
    var b11 = -a22 * a10 + a12 * a20;
    var b21 = a21 * a10 - a11 * a20;
    // Calculate the determinant
    var det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
}
function $879d8210211d0bfa$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    out[0] = a11 * a22 - a12 * a21;
    out[1] = a02 * a21 - a01 * a22;
    out[2] = a01 * a12 - a02 * a11;
    out[3] = a12 * a20 - a10 * a22;
    out[4] = a00 * a22 - a02 * a20;
    out[5] = a02 * a10 - a00 * a12;
    out[6] = a10 * a21 - a11 * a20;
    out[7] = a01 * a20 - a00 * a21;
    out[8] = a00 * a11 - a01 * a10;
    return out;
}
function $879d8210211d0bfa$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
function $879d8210211d0bfa$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b00 = b[0], b01 = b[1], b02 = b[2];
    var b10 = b[3], b11 = b[4], b12 = b[5];
    var b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
function $879d8210211d0bfa$export$d73ee8ef04f5226a(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
function $879d8210211d0bfa$export$bb628a54ab399bc9(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
function $879d8210211d0bfa$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = v[0];
    out[7] = v[1];
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = -s;
    out[4] = c;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = v[1];
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$68f5977575fae9bf(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = 0;
    out[3] = a[2];
    out[4] = a[3];
    out[5] = 0;
    out[6] = a[4];
    out[7] = a[5];
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
}
function $879d8210211d0bfa$export$966b25ab6dc1b1f9(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
}
function $879d8210211d0bfa$export$b74061472fe7c07(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$42d51816ce590c93(a) {
    return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
}
function $879d8210211d0bfa$export$326827e8268e9cdb(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3] + a[4] * a[4] + a[5] * a[5] + a[6] * a[6] + a[7] * a[7] + a[8] * a[8]);
}
function $879d8210211d0bfa$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
}
function $879d8210211d0bfa$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
}
function $879d8210211d0bfa$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
}
function $879d8210211d0bfa$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    return out;
}
function $879d8210211d0bfa$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
function $879d8210211d0bfa$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
var $879d8210211d0bfa$export$6e3a27864ab166fe = $879d8210211d0bfa$export$2060d2db72cce88f;
var $879d8210211d0bfa$export$f93b5905241a7cca = $879d8210211d0bfa$export$4e2d2ead65e5f7e3;

var $4ce98914b6676340$exports = {};

$parcel$export($4ce98914b6676340$exports, "create", () => $4ce98914b6676340$export$185802fd694ee1f5);
$parcel$export($4ce98914b6676340$exports, "clone", () => $4ce98914b6676340$export$9cd59f9826255e47);
$parcel$export($4ce98914b6676340$exports, "fromValues", () => $4ce98914b6676340$export$a82be99ed2a44a7d);
$parcel$export($4ce98914b6676340$exports, "copy", () => $4ce98914b6676340$export$784d13d8ee351f07);
$parcel$export($4ce98914b6676340$exports, "set", () => $4ce98914b6676340$export$adaa4cf7ef1b65be);
$parcel$export($4ce98914b6676340$exports, "add", () => $4ce98914b6676340$export$e16d8520af44a096);
$parcel$export($4ce98914b6676340$exports, "subtract", () => $4ce98914b6676340$export$4e2d2ead65e5f7e3);
$parcel$export($4ce98914b6676340$exports, "multiply", () => $4ce98914b6676340$export$2060d2db72cce88f);
$parcel$export($4ce98914b6676340$exports, "divide", () => $4ce98914b6676340$export$cd007d971a5a2143);
$parcel$export($4ce98914b6676340$exports, "ceil", () => $4ce98914b6676340$export$803ce6b71a0a94b2);
$parcel$export($4ce98914b6676340$exports, "floor", () => $4ce98914b6676340$export$a3fe094919f356fd);
$parcel$export($4ce98914b6676340$exports, "min", () => $4ce98914b6676340$export$96ec731ed4dcb222);
$parcel$export($4ce98914b6676340$exports, "max", () => $4ce98914b6676340$export$8960430cfd85939f);
$parcel$export($4ce98914b6676340$exports, "round", () => $4ce98914b6676340$export$2077e0241d6afd3c);
$parcel$export($4ce98914b6676340$exports, "scale", () => $4ce98914b6676340$export$dcdf75081b88279d);
$parcel$export($4ce98914b6676340$exports, "scaleAndAdd", () => $4ce98914b6676340$export$19cedf1da84ba854);
$parcel$export($4ce98914b6676340$exports, "distance", () => $4ce98914b6676340$export$9f17032d917177de);
$parcel$export($4ce98914b6676340$exports, "squaredDistance", () => $4ce98914b6676340$export$88e6ebb4fe54f538);
$parcel$export($4ce98914b6676340$exports, "length", () => $4ce98914b6676340$export$f24224f1c91d8156);
$parcel$export($4ce98914b6676340$exports, "squaredLength", () => $4ce98914b6676340$export$ab44e1323ffc8376);
$parcel$export($4ce98914b6676340$exports, "negate", () => $4ce98914b6676340$export$aef51622e549b8b0);
$parcel$export($4ce98914b6676340$exports, "inverse", () => $4ce98914b6676340$export$70ae2c07e401031b);
$parcel$export($4ce98914b6676340$exports, "normalize", () => $4ce98914b6676340$export$a3295358bff77e);
$parcel$export($4ce98914b6676340$exports, "dot", () => $4ce98914b6676340$export$94132a0e348806d4);
$parcel$export($4ce98914b6676340$exports, "cross", () => $4ce98914b6676340$export$bb646b20bb93d339);
$parcel$export($4ce98914b6676340$exports, "lerp", () => $4ce98914b6676340$export$3a89f8d6f6bf6c9f);
$parcel$export($4ce98914b6676340$exports, "random", () => $4ce98914b6676340$export$4385e60b38654f68);
$parcel$export($4ce98914b6676340$exports, "transformMat2", () => $4ce98914b6676340$export$b732428d73874bfc);
$parcel$export($4ce98914b6676340$exports, "transformMat2d", () => $4ce98914b6676340$export$3e55bc4b3707dfd3);
$parcel$export($4ce98914b6676340$exports, "transformMat3", () => $4ce98914b6676340$export$f0bfa0a0024626ee);
$parcel$export($4ce98914b6676340$exports, "transformMat4", () => $4ce98914b6676340$export$5ffbd13800309d59);
$parcel$export($4ce98914b6676340$exports, "rotate", () => $4ce98914b6676340$export$bb628a54ab399bc9);
$parcel$export($4ce98914b6676340$exports, "angle", () => $4ce98914b6676340$export$944b09d2ad10b378);
$parcel$export($4ce98914b6676340$exports, "signedAngle", () => $4ce98914b6676340$export$2c039ab0034c6824);
$parcel$export($4ce98914b6676340$exports, "zero", () => $4ce98914b6676340$export$7f9972325ebfd559);
$parcel$export($4ce98914b6676340$exports, "str", () => $4ce98914b6676340$export$42d51816ce590c93);
$parcel$export($4ce98914b6676340$exports, "exactEquals", () => $4ce98914b6676340$export$f2599a5cf1109d8);
$parcel$export($4ce98914b6676340$exports, "equals", () => $4ce98914b6676340$export$e9bab7fafb253603);
$parcel$export($4ce98914b6676340$exports, "len", () => $4ce98914b6676340$export$fc1400facf92c78);
$parcel$export($4ce98914b6676340$exports, "sub", () => $4ce98914b6676340$export$f93b5905241a7cca);
$parcel$export($4ce98914b6676340$exports, "mul", () => $4ce98914b6676340$export$6e3a27864ab166fe);
$parcel$export($4ce98914b6676340$exports, "div", () => $4ce98914b6676340$export$159d9494db57879b);
$parcel$export($4ce98914b6676340$exports, "dist", () => $4ce98914b6676340$export$6c4a311cc157c764);
$parcel$export($4ce98914b6676340$exports, "sqrDist", () => $4ce98914b6676340$export$2422cd6c492a8b3a);
$parcel$export($4ce98914b6676340$exports, "sqrLen", () => $4ce98914b6676340$export$99d8dd3f32a3435);
$parcel$export($4ce98914b6676340$exports, "forEach", () => $4ce98914b6676340$export$4b80e395e36b5a56);

function $4ce98914b6676340$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(2);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $4ce98914b6676340$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $4ce98914b6676340$export$a82be99ed2a44a7d(x, y) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $4ce98914b6676340$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $4ce98914b6676340$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $4ce98914b6676340$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $4ce98914b6676340$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $4ce98914b6676340$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $4ce98914b6676340$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $4ce98914b6676340$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $4ce98914b6676340$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $4ce98914b6676340$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $4ce98914b6676340$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $4ce98914b6676340$export$2077e0241d6afd3c(out, a) {
    out[0] = $78ae820aa9ececfa$export$2077e0241d6afd3c(a[0]);
    out[1] = $78ae820aa9ececfa$export$2077e0241d6afd3c(a[1]);
    return out;
}
function $4ce98914b6676340$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $4ce98914b6676340$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $4ce98914b6676340$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.sqrt(x * x + y * y);
}
function $4ce98914b6676340$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $4ce98914b6676340$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.sqrt(x * x + y * y);
}
function $4ce98914b6676340$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $4ce98914b6676340$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $4ce98914b6676340$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $4ce98914b6676340$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $4ce98914b6676340$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $4ce98914b6676340$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $4ce98914b6676340$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $4ce98914b6676340$export$4385e60b38654f68(out, scale) {
    scale = scale === undefined ? 1.0 : scale;
    var r = $78ae820aa9ececfa$export$5ada478c8a628231() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $4ce98914b6676340$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $4ce98914b6676340$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $4ce98914b6676340$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $4ce98914b6676340$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $4ce98914b6676340$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad);
    //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $4ce98914b6676340$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1];
    return Math.abs(Math.atan2(ay * bx - ax * by, ax * bx + ay * by));
}
function $4ce98914b6676340$export$2c039ab0034c6824(a, b) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1];
    return Math.atan2(ax * by - ay * bx, ax * bx + ay * by);
}
function $4ce98914b6676340$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $4ce98914b6676340$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $4ce98914b6676340$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $4ce98914b6676340$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $4ce98914b6676340$export$fc1400facf92c78 = $4ce98914b6676340$export$f24224f1c91d8156;
var $4ce98914b6676340$export$f93b5905241a7cca = $4ce98914b6676340$export$4e2d2ead65e5f7e3;
var $4ce98914b6676340$export$6e3a27864ab166fe = $4ce98914b6676340$export$2060d2db72cce88f;
var $4ce98914b6676340$export$159d9494db57879b = $4ce98914b6676340$export$cd007d971a5a2143;
var $4ce98914b6676340$export$6c4a311cc157c764 = $4ce98914b6676340$export$9f17032d917177de;
var $4ce98914b6676340$export$2422cd6c492a8b3a = $4ce98914b6676340$export$88e6ebb4fe54f538;
var $4ce98914b6676340$export$99d8dd3f32a3435 = $4ce98914b6676340$export$ab44e1323ffc8376;
var $4ce98914b6676340$export$4b80e395e36b5a56 = function() {
    var vec = $4ce98914b6676340$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();


class $1b760e9f48535ac8$export$8b759ae4f2ad5904 {
    constructor(){
        this.matrix = (0, $879d8210211d0bfa$exports).create(); // Identity matrix by default
        this.gridSize = 5; // 5x5 grid
        this.gridSpacing = 1;
        // DOM elements
        this.originalSvg = document.getElementById('original-grid');
        this.transformedSvg = document.getElementById('transformed-grid');
        this.matrixInputs = {
            m00: document.getElementById('m00'),
            m01: document.getElementById('m01'),
            m02: document.getElementById('m02'),
            m10: document.getElementById('m10'),
            m11: document.getElementById('m11'),
            m12: document.getElementById('m12')
        };
        this.init();
    }
    /**
     * Initialize the visualizer
     */ init() {
        this.setupEventListeners();
        this.renderOriginalGrid();
        this.updateMatrix();
    }
    /**
     * Setup event listeners for matrix inputs
     */ setupEventListeners() {
        Object.values(this.matrixInputs).forEach((input)=>{
            input.addEventListener('input', ()=>this.updateMatrix());
        });
    }
    /**
     * Update the transformation matrix from input values
     */ updateMatrix() {
        // Read values from inputs
        const m00 = parseFloat(this.matrixInputs.m00.value) || 0;
        const m01 = parseFloat(this.matrixInputs.m01.value) || 0;
        const m02 = parseFloat(this.matrixInputs.m02.value) || 0;
        const m10 = parseFloat(this.matrixInputs.m10.value) || 0;
        const m11 = parseFloat(this.matrixInputs.m11.value) || 0;
        const m12 = parseFloat(this.matrixInputs.m12.value) || 0;
        // gl-matrix uses column-major format
        // [m00 m10 0]
        // [m01 m11 0]
        // [m02 m12 1]
        (0, $879d8210211d0bfa$exports).set(this.matrix, m00, m01, m02, m10, m11, m12, 0, 0, 1);
        this.renderTransformedGrid();
    }
    /**
     * Render the original grid
     */ renderOriginalGrid() {
        this.renderGrid(this.originalSvg, null);
    }
    /**
     * Render the transformed grid
     */ renderTransformedGrid() {
        this.renderGrid(this.transformedSvg, this.matrix);
    }
    /**
     * Render a grid with optional transformation
     * @param {SVGElement} svg - The SVG element to render into
     * @param {mat3|null} transformMatrix - Optional transformation matrix
     */ renderGrid(svg, transformMatrix) {
        // Clear existing content
        svg.innerHTML = '';
        const halfSize = Math.floor(this.gridSize / 2);
        const lines = [];
        const axes = [];
        // Generate grid lines
        for(let i = -halfSize; i <= halfSize; i++){
            // Vertical lines
            const vStart = (0, $4ce98914b6676340$exports).fromValues(i * this.gridSpacing, -halfSize * this.gridSpacing);
            const vEnd = (0, $4ce98914b6676340$exports).fromValues(i * this.gridSpacing, halfSize * this.gridSpacing);
            if (transformMatrix) {
                this.transformPoint(vStart, transformMatrix);
                this.transformPoint(vEnd, transformMatrix);
            }
            if (i === 0) // Y-axis
            axes.push(this.createLine(vStart[0], vStart[1], vEnd[0], vEnd[1], 'axis'));
            else lines.push(this.createLine(vStart[0], vStart[1], vEnd[0], vEnd[1], 'grid-line'));
            // Horizontal lines
            const hStart = (0, $4ce98914b6676340$exports).fromValues(-halfSize * this.gridSpacing, i * this.gridSpacing);
            const hEnd = (0, $4ce98914b6676340$exports).fromValues(halfSize * this.gridSpacing, i * this.gridSpacing);
            if (transformMatrix) {
                this.transformPoint(hStart, transformMatrix);
                this.transformPoint(hEnd, transformMatrix);
            }
            if (i === 0) // X-axis
            axes.push(this.createLine(hStart[0], hStart[1], hEnd[0], hEnd[1], 'axis'));
            else lines.push(this.createLine(hStart[0], hStart[1], hEnd[0], hEnd[1], 'grid-line'));
        }
        // Add a unit square for reference
        const square = this.createSquare(transformMatrix);
        // Add styles
        const style = document.createElementNS('http://www.w3.org/2000/svg', 'style');
        style.textContent = `
            .grid-line { stroke: rgba(26, 26, 46, 0.2); stroke-width: 0.02; }
            .axis { stroke: rgba(74, 111, 216, 0.6); stroke-width: 0.04; }
            .unit-square { fill: rgba(26, 26, 46, 0.15); stroke: rgba(26, 26, 46, 0.6); stroke-width: 0.05; }
        `;
        svg.appendChild(style);
        // Append all elements (grid lines first, then axes, then square on top)
        lines.forEach((line)=>svg.appendChild(line));
        axes.forEach((axis)=>svg.appendChild(axis));
        svg.appendChild(square);
    }
    /**
     * Transform a point using the given matrix
     * @param {vec2} point - Point to transform (modified in place)
     * @param {mat3} matrix - Transformation matrix
     */ transformPoint(point, matrix) {
        const result = (0, $4ce98914b6676340$exports).create();
        (0, $4ce98914b6676340$exports).transformMat3(result, point, matrix);
        point[0] = result[0];
        point[1] = result[1];
    }
    /**
     * Create an SVG line element
     * @param {number} x1 - Start x coordinate
     * @param {number} y1 - Start y coordinate
     * @param {number} x2 - End x coordinate
     * @param {number} y2 - End y coordinate
     * @param {string} className - CSS class name
     * @returns {SVGLineElement}
     */ createLine(x1, y1, x2, y2, className) {
        const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line.setAttribute('x1', x1);
        line.setAttribute('y1', y1);
        line.setAttribute('x2', x2);
        line.setAttribute('y2', y2);
        line.setAttribute('class', className);
        return line;
    }
    /**
     * Create a unit square for visual reference
     * @param {mat3|null} transformMatrix - Optional transformation matrix
     * @returns {SVGPolygonElement}
     */ createSquare(transformMatrix) {
        // Unit square corners
        const corners = [
            (0, $4ce98914b6676340$exports).fromValues(0, 0),
            (0, $4ce98914b6676340$exports).fromValues(1, 0),
            (0, $4ce98914b6676340$exports).fromValues(1, 1),
            (0, $4ce98914b6676340$exports).fromValues(0, 1)
        ];
        if (transformMatrix) corners.forEach((corner)=>this.transformPoint(corner, transformMatrix));
        const points = corners.map((c)=>`${c[0]},${c[1]}`).join(' ');
        const polygon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        polygon.setAttribute('points', points);
        polygon.setAttribute('class', 'unit-square');
        return polygon;
    }
}


// Initialize on load
document.addEventListener('DOMContentLoaded', ()=>{
    // Update footer with build information
    const commitHashElement = document.getElementById('commit-hash');
    if (commitHashElement) commitHashElement.textContent = (0, $04b8cf952a63a727$export$d99074480c2c53b7).commit;
    // Initialize affine transformation visualizer
    new (0, $1b760e9f48535ac8$export$8b759ae4f2ad5904)();
});


//# sourceMappingURL=affvisine.20c24737.js.map
